import { useLayoutEffect, useState } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
// import Typography from '@mui/material/Typography';
// import support from "../../../../../assets/icons/support.svg";

// project import
import NavItem from './NavItem';
import menuItem from 'menu-items';

import useConfig from 'hooks/useConfig';
import { HORIZONTAL_MAX_ITEM, MenuOrientation } from 'config';
import { useGetMenuMaster } from 'api/menu';
import { V2 } from '../../drawerV2Tokens';
// import { bgcolor } from '@mui/system';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { menuOrientation } = useConfig();
  useGetMenuMaster();
  // const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const [menuItems, setMenuItems] = useState({ items: [] });

  useLayoutEffect(() => {
    setMenuItems(menuItem);
  }, []);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems.items.length - 1;
  let lastItemId;

  //  first it checks menu item is more than giving HORIZONTAL_MAX_ITEM after that get lastItemid by giving horizontal max
  // item and it sets horizontal menu by giving horizontal max item lastly slice menuItem from array and set into remItems
  // const supportItem = menuItems.items.find(item => item.id === 'Support');
  const regularItems = menuItems.items.filter(item => item.id !== 'Support');

  if (lastItem && lastItem < regularItems.length) {
    lastItemId = regularItems[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
  }

  const navGroups = regularItems.slice(0, lastItemIndex + 1).map((item, index) => {
    if (item.url && item.id !== lastItemId && !['learning','favorites','newsletter'].includes(item.id)) {
      return (
        <List key={item.id} sx={{py: '3px'}}>
          <NavItem item={item} level={1} isParents />
          {(index === 3 || index === 6) && (
            <Divider
              sx={{
                my: '8px !important',
                width: '72%',
                margin: 'auto',
                borderColor: V2.line,
              }}
            />
          )}
        </List>
      );
    }
    return null;
  });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
      }}
    >
      <Box >{navGroups}</Box>
   
    </Box>
  );
}
